import './LoadingUserAvatar.scoped.scss';
import { CSSProperties, FC } from 'react';

import classNames from 'classnames';

import Loader from 'clean/components/Loader/Loader';
import { useAppSelector } from 'redux/hooks';
import { profilePicture, profilePictureState } from 'redux/authentication/auth.slice';

type Props = {
  height?: number;
  width?: number;
  style?: CSSProperties;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LoadingUserAvatar: FC<Props> = ({ height = 100, width = 100, style }) => {
  const pxWidht = `${width.toString()}px`;
  const pxHeight = `${height.toString()}px`;

  const profilePicUrl = useAppSelector(profilePicture);
  const profilePictureLoading = useAppSelector(profilePictureState);

  return (
    <div
      className={classNames('loading-container', profilePictureLoading)}
      style={{ height: pxHeight, width: pxWidht }}
    >
      <img
        style={{ height: pxHeight, width: pxWidht, ...style }}
        src={profilePicUrl}
        alt="user profile"
      />
      <div className="loader">{profilePictureLoading === 'pending' && <Loader size={20} />}</div>
    </div>
  );
};

export default LoadingUserAvatar;
